import * as constants from './constants';
import { forgotPasswordSlice } from './slice';

export default { constants, forgotPasswordSlice };
